export const getDesignsDefaultLink = () => '/designs';
export const getSharedWithMeDefaultLink = () => '/shared';
export const getProjectsDefaultLink = () => '/projects';
export const getBrandColorsLink = () => '/brand-colors';
export const getNotFoundLink = () => '/not-found';
export const getCategoriesLink = () => '/categories';
export const getUploadsDefaultLink = () => '/uploads';
export const getActivityFeedDefaultLink = () => '/activity';
